import React from 'react'

import influencerData from '../../data-influencer/adrienne'
import PageBuilder from '../PageBuilder'
import PageLayout from './PageLayout'

const Adrienne = () => (
    <PageBuilder influencerData={influencerData}>
        <PageLayout />
    </PageBuilder>
)

export default Adrienne
